const BACKEND_BASE = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

export const authService = {
  authorize: async () => {
    const res = await fetch(`${BACKEND_BASE}/api/auth/gas/authorize`, { credentials: 'include' });
    return res.json();
  },
  me: async () => {
    const res = await fetch(`${BACKEND_BASE}/api/auth/me`, { credentials: 'include' });
    return res.json();
  },
  logout: async () => {
    const res = await fetch(`${BACKEND_BASE}/api/auth/logout`, { method: 'POST', credentials: 'include' });
    return res.json();
  },
  refreshSession: async (): Promise<{ authenticated: boolean; user: string | null; roles: string[] }> => {
    try {
      const res = await fetch(`${BACKEND_BASE}/api/auth/refresh`, { method: 'POST', credentials: 'include' });
      if (!res.ok) return { authenticated: false, user: null, roles: [] };
      return res.json();
    } catch {
      return { authenticated: false, user: null, roles: [] };
    }
  },
};

export default authService;
